<template>
	<div class="zixun-layout">
		<!-- 质量公告 -->
		<div class="quality-notice" v-if="noticeList && noticeList.length > 0">
			<a
				class="notice-content notice-link"
				href="/announcement"
				rel="nofollow"
				@click.prevent="
					() => {
						return false;
					}
				"
			>
				<div class="notice-title" @click.prevent="toNoticeList"></div>
				<div class="notice-right" @click.prevent="toNoticeList">
					<van-swipe class="notice-swiper" :autoplay="3000" :duration="500" vertical :show-indicators="false" :touchable="false">
						<van-swipe-item v-for="(item, i) in noticeList" :key="i">
							<div class="notice-text">{{ item.title }}</div>
						</van-swipe-item>
					</van-swipe>
				</div>
			</a>
		</div>

		<!-- 店铺资讯 -->
		<a class="flex no-pad gykx news-link" v-if="newsList.length > 0" rel="nofollow" href="/topstory" @click.prevent="toNewsList">
			<div class="flex no-pad items-center">
				<nuxt-img :quality="99" src="/staticSeo/images/home/gykx.png" width="186" height="42" alt="国药快讯" />
				<van-swipe class="lunbo" :autoplay="newsSwiperAutoplay" :duration="500" vertical :show-indicators="false" :touchable="false">
					<van-swipe-item v-for="(item, i) in newsList" :key="i">
						<div class="text">{{ item.title }}</div>
					</van-swipe-item>
				</van-swipe>
			</div>
		</a>
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
	newsList: {
		type: Array,
		default: () => [],
	},
	noticeList: {
		type: Array,
		default: () => [],
	},
});

const newsSwiperAutoplay = ref(0);

onMounted(() => {
	// 店铺资讯轮播延迟1.5秒后开始自动播放，与质量公告错开
	setTimeout(() => {
		newsSwiperAutoplay.value = 3000;
	}, 1500);
});

const toNoticeList = () => {
	navigateTo('/announcement');
};

const toNewsList = () => {
	navigateTo('/topstory');
};
</script>

<style lang="scss" scoped>
.zixun-layout {
	padding: 0 8px;
	margin: 6px 0;
}

/* 质量公告样式 */
.quality-notice {
	width: 100%;
	height: 34px;
	background: url('@/assets/images/quantity-pub.png') no-repeat center center;
	background-size: 100% 100%;
	border-radius: 5px 5px 0 0;
	display: flex;
	align-items: center;
	justify-content: flex-end;

	.notice-content {
		flex: 1;
		height: 100%;
		display: flex;
		align-items: center;
		padding-right: 150px;
		min-width: 0;
		text-decoration: none;
		color: inherit;

		/* 右侧客服电话区域留出空间 */
		.notice-title {
			width: 82px;
			height: 100%;
			display: inline-block;
		}

		.notice-right {
			flex: 1;
			min-width: 0;
			display: flex;
		}
	}

	.notice-swiper {
		width: 100%;
		height: 20px;

		:deep(.van-swipe__track) {
			height: 20px !important;
		}

		.notice-text {
			font-family: NotoSansSC-Regular, NotoSansSC;
			font-weight: 400;
			font-size: 12px;
			color: #333333;
			overflow: hidden;
			text-overflow: ellipsis;
			word-break: break-all;
			white-space: nowrap;
			line-height: 20px;
			max-width: 100%;
		}
	}
}

.gykx {
	padding: 0.5rem 1.83rem 0.5rem 1rem;
	background: #fff;
	border-radius: 0 0 5px 5px;
	padding-right: 0;
	text-decoration: none;
	color: inherit;

	img {
		width: 56px;
	}

	.lunbo {
		height: 20px;
		width: 270px;
		margin-left: 12px;

		:deep(.van-swipe__track) {
			height: 20px !important;
		}

		.text {
			font-family: NotoSansSC-Regular, NotoSansSC;
			font-weight: 400;
			font-size: 12px;
			color: #333333;
			overflow: hidden;
			text-overflow: ellipsis;
			word-break: break-all;
			white-space: nowrap;
			line-height: 20px;
		}
	}

	.icon-gongneng_xiangyou-37 {
		font-size: 1rem;
		color: #909399;
	}
}
</style>
